import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';

// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/autosuggest-highlight` if ... Remove this comment to see the full error message
import match from 'autosuggest-highlight/match';

// @ts-ignore ts-migrate(7016) FIXME: Try `npm install @types/autosuggest-highlight` if ... Remove this comment to see the full error message
import parse from 'autosuggest-highlight/parse';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from './TextField';
import { isUndefined } from '../../core/util/object';

function renderInput(inputProps: any) {
  const { ref, ...others } = inputProps;
  return (
    <TextField
      fullWidth
      id={inputProps.id ?? inputProps.label}
      InputProps={{
        inputRef: ref,
      }}
      {...others}
    />
  );
}

function renderSuggestionsContainer(options: any) {
  const { containerProps, children } = options;

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  );
}

function getSuggestions(value: any, suggestions: any) {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;
  let count = 0;

  if (inputLength === 0) {
    return [];
  }

  return suggestions.filter((suggestion: any) => {
    const keep = count < 5 && suggestion.label.toLowerCase().slice(0, inputLength) === inputValue;

    if (keep) {
      count += 1;
    }

    return keep;
  });
}

type Props = {
  classes?: any;
  theme?: any;
  suggestions: any[];
  onChange?: (...args: any[]) => any;
  value?: string;
  customSuggestionsFilter?: (...args: any[]) => any;
  getValueFromSuggestion?: (...args: any[]) => any;
  renderSuggestion?: (...args: any[]) => any;
  styleTheme: any;
  renderInput?: (...args: any[]) => any;
};

type State = any;

class IntegrationAutosuggest extends Component<Props, State> {
  state = {
    value: '',
    suggestions: [],
  };

  componentDidUpdate = (prevProps: any) => {
    if (JSON.stringify(this.props.suggestions) !== JSON.stringify(prevProps.suggestions)) {
      this.handleSuggestionsFetchRequested({
        value: this.state.value,
        reason: 'new-data',
      });
    }
  };

  getSuggestionValue = (suggestion: any) => {
    if (this.props.getValueFromSuggestion) {
      return this.props.getValueFromSuggestion(suggestion);
    }

    return suggestion.label;
  };

  handleChange = (event: any, { newValue }: any) => {
    this.setState({
      value: newValue,
    });
  };

  handleSuggestionsFetchRequested = ({ value, reason }: any) => {
    const { suggestions, customSuggestionsFilter } = this.props;
    if (!isUndefined(customSuggestionsFilter)) {
      this.setState({
        value,

        // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
        suggestions: customSuggestionsFilter(value, suggestions),
      });
    } else {
      this.setState({
        value,
        suggestions: getSuggestions(value, suggestions),
      });
    }
  };

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  renderSuggestion = (suggestion: any, properties: any) => {
    const { query, isHighlighted } = properties;
    if (this.props.renderSuggestion) {
      return this.props.renderSuggestion(suggestion, properties);
    }

    const matches = match(suggestion.label, query);
    const parts = parse(suggestion.label, matches);

    return (
      <MenuItem component="div" selected={isHighlighted}>
        <div>
          {parts.map((part: any) =>
            part.isHighlighted ? (
              <span key={part.text} style={{ fontWeight: 300 }}>
                {part.text}
              </span>
            ) : (
              <strong key={part.text} style={{ fontWeight: 500 }}>
                {part.text}
              </strong>
            )
          )}
        </div>
      </MenuItem>
    );
  };

  render() {
    const { styleTheme, classes, customSuggestionsFilter, ...others } = this.props;
    const value = this.props.value ? this.props.value : this.state.value;
    const onChange = this.props.onChange ? this.props.onChange : this.handleChange;
    const renderInputComponent = this.props.renderInput ? this.props.renderInput : renderInput;
    const theme = styleTheme;
    const inputProps = { value, onChange, ...others };
    return (
      <Autosuggest
        {...this.props}
        // @ts-expect-error ts-migrate(2769) FIXME: Property 'classes' does not exist on type '(Intrin... Remove this comment to see the full error message
        classes={classes}
        getSuggestionValue={this.getSuggestionValue}
        inputProps={inputProps}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        renderInputComponent={renderInputComponent}
        renderSuggestion={this.renderSuggestion}
        renderSuggestionsContainer={renderSuggestionsContainer}
        suggestions={this.state.suggestions}
        theme={theme}
      />
    );
  }
}

export default IntegrationAutosuggest;
